import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/containers/Home'
import Work from '@/containers/Work'
import About from '@/containers/About'
import Directors from '@/containers/Directors'
import Contact from '@/containers/Contact'
import Locations from '@/containers/Locations'
import Clients from '@/containers/Clients'
import Productions from '@/containers/Productions'
import LongFormat from '@/containers/LongFormat'

Vue.use(Router)

export default new Router({
  //mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/works',
      name: 'works',
      component: Work
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: About
    },
    {
      path: '/directors',
      name: 'directors',
      component: Directors
    },
    {
      path: '/locations',
      name: 'locations',
      component: Locations
    },
    {
      path: '/clients',
      name: 'clients',
      component: Clients
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: Contact
    },
    // {
    //   path: '/productions',
    //   name: 'productions',
    //   component: Productions
    // },
    {
      path: '/longformat',
      name: 'worksLongFormat',
      component: LongFormat
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js